import { React, useState } from 'react';
import { Transition } from '@headlessui/react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebook } from '@fortawesome/free-brands-svg-icons';
import NavMenu from './NavMenu';
import MobileMenu from './MobileMenu';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const specialNeedsServices = {
    mainTitle: 'Special Needs Services',
    subMenuItems: [
      { title: 'Behaviour Therapy', link: 'behaviour-therapy' },
      { title: 'Speech Language Pathology', link: 'speech-therapy' },
      { title: 'Occupational Therapy', link: 'occupational-therapy' },
      { title: 'Aide Services', link: 'aide-services' },
      { title: 'Respite Services', link: 'respite-services' },
      //{ title: 'Music Therapy', link: 'services' },
      { title: 'FSCD Partnership', link: 'fscd-partnership' },
      {
        title: 'FSCD Coordination Services',
        link: 'fscd-coordination-services',
      },
      {
        title: 'Pediatric Developmental Sessions',
        link: 'pediatric-developmental-sessions',
      },
      {
        title: 'Adult Developmental Sessions',
        link: 'adult-developmental-sessions',
      },
      {
        title: 'PDD Partnership',
        link: 'pdd',
      },
    ],
  };
  const academicLessons = {
    mainTitle: 'Private Academic Lessons',
    subMenuItems: [
      { title: 'Overview', link: 'private-lessons-overview' },
      { title: 'Kindergarten to Grade 6', link: 'kindergarten-to-grade-6' },
      { title: 'Junior High', link: 'junior-high' },
      { title: 'Senior High', link: 'senior-high' },
      {
        title:
          'International Baccalaureate (IB) \n and Advanced Placement (AP)',
        link: 'ib-and-ap',
      },
      {
        title: 'University Admission Preparation',
        link: 'university-admission',
      },
    ],
  };
  const about = {
    mainTitle: 'About Us',
    subMenuItems: [
      { title: 'Our Team', link: 'our-team' },
      { title: 'Work with Us', link: 'work-with-us' },
      { title: 'Contact', link: 'contact' },
    ],
  };
  return (
    <div>
      <nav className='bg-white'>
        <div className='max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8'>
          <div className='flex items-bottom justify-between h-20'>
            <nav className='flex items-center list-none'>
              <Link to='/' onClick={() => setIsOpen(false)}>
                <img
                  className='h-16 w-50 hover:bg-darkest p-2 rounded-md text-sm font-medium'
                  src='/LinkandLearnLogoTrans.png'
                  alt='Workflow'
                />
              </Link>
              <ul className='hidden md:flex ml-10 space-x-4'>
                <li>
                  <NavMenu
                    mainTitle={specialNeedsServices.mainTitle}
                    subMenuItems={specialNeedsServices.subMenuItems}
                  />
                </li>
                <li>
                  <NavMenu
                    mainTitle={academicLessons.mainTitle}
                    subMenuItems={academicLessons.subMenuItems}
                  />
                </li>
                <li>
                  <NavMenu
                    mainTitle={about.mainTitle}
                    subMenuItems={about.subMenuItems}
                  />
                </li>
              </ul>
            </nav>
            <div className='flex items-center space-x-4'>
              <a href='https://www.instagram.com/link_and_learn/' target='_blank' rel='noopener noreferrer'>
                <FontAwesomeIcon icon={faInstagram} className='text-gray-900 hover:text-black' size='lg' />
              </a>
              <a href='https://www.facebook.com/linkandlearnyyc' target='_blank' rel='noopener noreferrer'>
                <FontAwesomeIcon icon={faFacebook} className='text-gray-900 hover:text-black' size='lg' />
              </a>
            <div className='-mr-2 flex md:hidden'>
              <button
                onClick={() => setIsOpen(!isOpen)}
                type='button'
                className='bg-gray-900 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-black hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-black'
                aria-controls='mobile-menu'
                aria-expanded='false'
              >
                {!isOpen ? (
                  <svg
                    className='block h-6 w-6'
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                    aria-hidden='true'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M4 6h16M4 12h16M4 18h16'
                    />
                  </svg>
                ) : (
                  <svg
                    className='block h-6 w-6'
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                    aria-hidden='true'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M6 18L18 6M6 6l12 12'
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>
        </div>

        <Transition
          show={isOpen}
          enter='transition ease-out duration-100 transform'
          enterFrom='opacity-0 scale-95'
          enterTo='opacity-100 scale-100'
          leave='transition ease-in duration-75 transform'
          leaveFrom='opacity-100 scale-100'
          leaveTo='opacity-0 scale-95'
        >
          {(ref) => (
            <div className='md:hidden' id='mobile-menu'>
              <li
                ref={ref}
                className='px-2 pt-2 pb-3 space-y-1 sm:px-3 list-none'
              >
                <MobileMenu
                  mainTitle={specialNeedsServices.mainTitle}
                  subMenuItems={specialNeedsServices.subMenuItems}
                  setIsParentMenuOpen={setIsOpen}
                />
                <MobileMenu
                  mainTitle={academicLessons.mainTitle}
                  subMenuItems={academicLessons.subMenuItems}
                  setIsParentMenuOpen={setIsOpen}
                />
                <MobileMenu
                  mainTitle={about.mainTitle}
                  subMenuItems={about.subMenuItems}
                  setIsParentMenuOpen={setIsOpen}
                />
              </li>
            </div>
          )}
        </Transition>
      </nav>
    </div>
  );
};

export default Navbar;
